import { createStore } from "vuex";
import config from "../config";
import axios from "axios";
import { useCookies } from 'vue3-cookies'; // Импортируем VueCookies

const { cookies } = useCookies();

// Создаем новый экземпляр axios с настройками
const apiClient = axios.create({
    baseURL: 'https://id.molepool.com/api',  // Базовый URL API
    withCredentials: true,  // Важно! Это гарантирует, что куки отправляются с каждым запросом
});

const coin = config.coin.toLowerCase()

export default createStore({
    state: {
        isAuthenticated: false,  // Статус авторизации
        userEmail: '',           // Email пользователя (после авторизации)
        status: "pending",
        error: "",
        newBlock: 0,
        home: {
            algo: "",
            scheme: "",
            reward: 0,
            fee: 0,
            totalMiners: 0,
            totalHashrate: 0,
            currentEffort: 0,
            lastBlockFound: 0,
            newBlocks: 0,
            totalBlocks: 0,
            networkHashrate: 0,
            networkDifficulty: 0,
            currentHeight: 0,
            btc: "",
            btc_24h_change: "",
            usd: "",
            usd_24h_change: "",
            chart: [],
        },
        blocks: {
            luck: {},
            candidate: [],
            blocks: [],
        },
        miners: {
            miners: [],
            totalCount: 0,
        },
        account: {
            currentHashrate: 0,
            averageHashrate: 0,
            lastBlockFound: 0,
            blocksFound: 0,
            personalShares: 0,
            personalEffort: 0,
            balance: 0,
            pending: 0,
            immature: 0,
            daysReward: 0,
            workerTotal: 0,
            workerOnline: 0,
            workerOffline: 0,
            chart: [],
            bestShare: {
                time: 0,
                share: 0,
                netDiff: 0,
                port: 0,
            },
            workers: []
        },
        account_workers: {
            workerTotal: 0,
            workerOnline: 0,
            workerOffline: 0,
            workers: []
        },
        account_rewards: {
            luck: {},
            sumrewards: [],
            rewards: []
        },
        account_payments: []
    },
    getters: {
        getStatus: (state) => state.status,
        getNewBlocks: (state) => state.newBlock,
        getHome: (state) => state.home,
        getBlocks: (state) => state.blocks,
        getMiners: (state) => state.miners,
        getAccount: (state) => state.account,
        getAccountWorkers: (state) => state.account_workers,
        getAccountRewards: (state) => state.account_rewards,
        getAccountPayments: (state) => state.account_payments,
        isAuthenticated: state => state.isAuthenticated,
        userEmail: state => state.userEmail
    },
    actions: {
        async fetchNewBlock({ commit }) {
            try {
                const data = await axios.get(`/api/v1/newBlock`);
                commit("SET_NEW_BLOCKS", data.data);
            } catch (error) {
                commit("SET_ERROR", error);
            }
        },
        async fetchHome({ commit }) {
            try {
                const data = await axios.get(`/api/v1/stats`);
                commit("SET_HOME", data.data.result);
                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        async fetchBlocks({ commit }) {
            try {
                const data = await axios.get(`/api/v1/blocks`);
                commit("SET_BLOCKS", data.data.result);
                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        async fetchMiners({ commit }, params) {
            try {
                const data = await axios.get(`/api/v1/miners/${params.page}/${params.size}`
                );
                commit("SET_MINERS", data.data.result);
                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        async fetchAccount({ commit }, params) {
            try {
                const data = await axios.get(`/api/v1/account/${params.login}/${params.page}/${params.size}`);
                commit("SET_ACCOUNT", data.data.result);
                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        async fetchAccountWorkerOffline({ commit }, params) {
            try {
                const data = await axios.get(`/api/v1/account/${params.login}/1/1000`);

                // Фильтруем только оффлайн воркеров
                const filteredResult = {
                    workers: data.data.result.workers.filter(worker => worker.offline),
                };

                commit("SET_ACCOUNT_WORKER_OFFLINE", filteredResult);

                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        async fetchAccountRewards({ commit }, params) {
            try {
                const data = await axios.get(`/api/v1/account/${params.login}/rewards`);
                commit("SET_ACCOUNT_REWARDS", data.data.result);
                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        async fetchAccountPayments({ commit }, params) {
            try {
                const data = await axios.get(`/api/v1/account/${params.login}/payments`);
                commit("SET_ACCOUNT_PAYMENTS", data.data.result);
                if (data.data.status) {
                    commit("SET_STATUS", "success");
                } else {
                    commit("SET_STATUS", "pending");
                }
            } catch (error) {
                commit("SET_STATUS", "error");
                commit("SET_ERROR", error);
            }
        },
        ///////////////////////////////
        // Проверка токена и авторизация
        async verifyToken({ commit, dispatch }) {
            try {
                const response = await apiClient.get('/verify');
                if (response.data.valid) {
                    commit('SET_AUTH', true);
                    commit('SET_USER_EMAIL', response.data.email);  // Сохраняем email пользователя
                } else {
                    commit('SET_AUTH', false);
                    commit('SET_USER_EMAIL', null);
                }
            } catch (error) {
                commit('SET_AUTH', false);
                commit('SET_USER_EMAIL', null);
                commit("SET_ERROR", error);
            }
        },

        // Действие для выхода из системы
        async logout({ commit }) {
            try {
                await apiClient.post('/logout');  // Отправляем запрос на сервер для завершения сессии
                // Удаляем куку isAuthenticated при выходе из системы
                cookies.remove("isAuthenticated", "/", ".molepool.com");
                commit('SET_AUTH', false);
                commit('SET_USER_EMAIL', '');
            } catch (error) {
                commit('SET_AUTH', false);
                commit('SET_USER_EMAIL', null);
                commit("SET_ERROR", error);
            }
        }

    },
    mutations: {
        SET_AUTH(state, status) {
            state.isAuthenticated = status;
        },
        SET_USER_EMAIL(state, email) {
            state.userEmail = email;
        },
        SET_STATUS(state, status) {
            state.status = status;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        SET_NEW_BLOCKS(state, newBlock) {
            state.newBlock = newBlock;
        },
        SET_HOME(state, home) {
            state.home = home;
        },
        SET_BLOCKS(state, blocks) {
            state.blocks = blocks;
        },
        SET_MINERS(state, miners) {
            state.miners = miners;
        },
        SET_ACCOUNT(state, account) {
            state.account = account;
        },
        SET_ACCOUNT_WORKER_OFFLINE(state, account_workers) {
            state.account_workers = account_workers;
        },
        SET_ACCOUNT_REWARDS(state, account_rewards) {
            state.account_rewards = account_rewards;
        },
        SET_ACCOUNT_PAYMENTS(state, account_payments) {
            state.account_payments = account_payments;
        },
    },
});
